import { handleApiError } from "./utils/handleApiError";

const ZOHO = window.ZOHO;

const EDIT_VIEW = "EditView";

export const initializeZoho = async ({ height, width }) => {
  try {
    const settledPromise = await new Promise((resolve, reject) => {
      let initialData = null;
      let initZoho = null;

      ZOHO.embeddedApp.on("PageLoad", async function (data) {
        const convertToArray = data?.ButtonPosition === EDIT_VIEW;
        const newEntityId = convertToArray ? [data?.EntityId] : data?.EntityId;
        const tempObj = newEntityId ? { EntityId: newEntityId } : {};
        initialData = { ...data, ...tempObj };

        if (initZoho !== null) {
          resolve({ initialData, initZoho });
        }
      });

      ZOHO.embeddedApp
        .init()
        .then(() => {
          initZoho = true;

          if (height && width) {
            ZOHO.CRM.UI.Resize({ height, width });
          }

          if (initialData !== null) {
            resolve({ initialData, initZoho });
          }
        })
        .catch((err) => {
          const customError = new Error("Failed to initialized ZOHO");
          reject(customError);
        });
    });
    return { data: settledPromise, error: null };
  } catch (error) {
    return {
      data: null,
      error: handleApiError("initializeZoho", error),
    };
  }
};

export const resizeWindow = async ({ height, width }) => {
  try {
    const resizeResp = await ZOHO.CRM.UI.Resize({ height, width });
  } catch (error) {
    return {
      data: null,
      error: handleApiError("resizeWindow", error),
    };
  }
};

export const pub = {
  initializeZoho,
  resizeWindow,
};
